import React, {Component} from "react";
import SplashScreen from "../splash-screen";
import Input from "../components/input";
import {
  checkCustomerNextProrationInvoice,
  fetchPlanData,
  getGiftCode,
  getSubscriptionStatusAndStreamingToken,
  getUserInfo, hasAuth,
  redeemCode,
  getRentalGiftCode,
  redeemRentalGift
} from "../services/api";
import {getPlanInfo} from "../plans";

export default class ClaimGift extends Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.loading = this.loading.bind(this)
    this.giftcodeOnChange = this.giftcodeOnChange.bind(this)
    this.loadGiftInformation = this.loadGiftInformation.bind(this)
    this.renderInitial = this.renderInitial.bind(this)
    this.renderConfirmation = this.renderConfirmation.bind(this)
    this.backToInitial = this.backToInitial.bind(this)
    this.initiateRedemption = this.initiateRedemption.bind(this)

    const step = 'initial';
    const userInfo = getUserInfo();
    const params = new URLSearchParams(this.props.location.search);
    const queryCode = params.get("code");

    this.state = {
      giftcode: '' || queryCode,
      loading: false,
      step,
      giftCodeInfo: {},
      planData: {},
      nextCharge: {},
      userInfo,
      error: '',
      isRentalGift: false
    }

    this.planNames = {
      "NYA-UNLIMITED-MONTHLY" : "NYA CLASSIC",
      "NYA-UNLIMITED-YEARLY" : "NYA CLASSIC",
      "NYA-UNLIMITEDV2-MONTHLY" : "NYA CLASSIC",
      "NYA-UNLIMITEDV2-YEARLY" : "NYA CLASSIC",
      "NYA-UNLIMITED-YEARLY-RUST" : "NYA RUST",
      "NYA-UNLIMITEDV2-YEARLY-RUST" : "NYA RUST",
      "NYA-UNLIMITED-YEARLY-PATRON" : "NYA PATRON",
    };

    if (queryCode) {
      this.loadGiftInformation()
    }
  }

  backToInitial() {
    this.setState({...this.state, step:'initial'})
  }

  giftcodeOnChange(value) {
    this.setState({...this.state, giftcode: value, error: ''})
  }

  checkIfUpgradeOrDowngrade(currentPlanName, newPlanName) {
    let action = "upgrade";
    if (
      (currentPlanName == "NYA RUST" && newPlanName == "NYA CLASSIC") ||
      (currentPlanName == "NYA PATRON" && (newPlanName == "NYA CLASSIC" || newPlanName == "NYA RUST"))
    ) {
      action = "downgrade";
    }
    return action;
  }

  async loadGiftInformation() {
    const giftcode = this.state.giftcode || ''
    const _hasAuth = hasAuth()
    if (!_hasAuth) {
      window.displayWarningMessage('sign-in')
      return
    }
    if (giftcode === '')
      return

    this.setState({...this.state, loading: true, error: ''})
    
    // Check if this is a rental gift code (starts with RG-)
    if (giftcode.toUpperCase().startsWith('RG-')) {
      try {
        const rentalGiftInfo = await getRentalGiftCode(giftcode);
        this.setState({
          ...this.state, 
          giftCodeInfo: rentalGiftInfo, 
          isRentalGift: true, 
          step: 'confirmation',
          loading: false
        });
      } catch (err) {
        this.setState({...this.state, error: 'Rental gift code is invalid or has already been redeemed!', loading: false})
      }
      return;
    }

    // Existing subscription gift flow
    try {
      const giftCodeInfo = await getGiftCode(giftcode);
      const planData = await fetchPlanData();
      const {subscription: subsInfo} = await getSubscriptionStatusAndStreamingToken()

      const planId = giftCodeInfo.planId || ''
      const currentPlanId = this.props.purchasedPlan.product_id
      const planTitle = this.planNames[planId]
      const currentPlanTitle = this.planNames[currentPlanId] || '';

      const action = this.checkIfUpgradeOrDowngrade(currentPlanTitle, planTitle)

      if (action === 'downgrade') {
        this.setState({...this.state, error: `You cannot change to ${planTitle} plan at this time. You have a ${currentPlanTitle} subscription`, step: 'initial', loading: false})
        return
      }

      if ((currentPlanId || '').includes("PATRON")) {
        this.setState({...this.state, error: 'You already have a Patron subscription', step: 'initial', loading: false})
        return
      }

      if (currentPlanId === giftCodeInfo.planId && subsInfo.active) {
        this.setState({...this.state, error: 'You already have this subscription plan', step: 'initial', loading: false})
        return
      }

      this.setState({...this.state, giftCodeInfo, planData, step: 'confirmation', isRentalGift: false})
    } catch (err) {
      this.setState({...this.state, error: 'Gift code is invalid or is already claimed!'})
    }
    this.setState({...this.state, loading: false})
  }

  async initiateRedemption () {
    this.setState({...this.state, loading: true, error: ''})

    if (this.state.isRentalGift) {
      // Rental gift redemption
      redeemRentalGift(this.state.giftcode).then((result) => {
        this.setState({
          ...this.state, 
          loading: false, 
          step: 'rental-success',
          rentalResult: result
        });
      }).catch((e) => {
        console.log(e)
        this.setState({...this.state, loading: false, step: 'initial', error: 'Failed to redeem rental gift. Please try again.'})
      });
    } else {
      // Subscription gift redemption
      redeemCode(this.state.giftcode).then(() => {
        window.history.replaceState({}, "", "/account?screen=overview");
      }).catch((e) => {
        console.log(e)
        const errorMessage = (e && e.response && e.response.body && e.response.body.message)
          || (e && typeof e.message === 'string' && e.message)
          || 'Failed to redeem gift code. Please try again or contact us.';
        this.setState({...this.state, loading: false, step: 'initial', error: errorMessage})
      });
    }
  }

  loading() {
    return (
      <div className="panel claim-panel">
        <div className="content initial spinner">
          <div style={{"marginBottom": "20px"}}>
            Loading...
          </div>
          <SplashScreen loadState={50}/>
        </div>
      </div>
    )
  }

  renderInitial() {
    const {error} = this.state
    return (
      <div className="claim-panel panel">
        <div className="title">Claim Gift</div>
        <div className="content">
          <div className="gift-message">
            Claim your gift to unlock exclusive benefits!
          </div>
          <div className="gift-form">
            <Input
              className="input--giftcode input"
              placeholder="Enter Gift Code"
              limit={30}
              value={this.state.giftcode}
              onChange={this.giftcodeOnChange}
              name="code"
            />
          </div>
          {error && <div className="error">{error}</div>}

          <div className="description-section">
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={this.loadGiftInformation}>
                CLAIM GIFT
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderConfirmation() {
    const { giftCodeInfo, planData, userInfo, isRentalGift } = this.state

    // Rental gift confirmation
    if (isRentalGift) {
      return (
        <div className="claim-panel panel">
          <div className="title">Claim Movie Gift</div>
          <div className="content">
            <div className="gift-message">
              Gift Details:
              <div className="gift-details">
                <h2>{giftCodeInfo.videoTitle}</h2>
                <div className="gift-description-text">
                  <p>{giftCodeInfo.rentalAvailability} day rental</p>
                  <p>Code: {this.state.giftcode}</p>
                </div>
              </div>
            </div>
            <div className="description-section">
              <div className="confirmation-message padding40">
                <h3 className="confirmation-title">What you need to know:</h3>
                <div className="explanation">
                  <p>You will have access to watch this movie for {giftCodeInfo.rentalAvailability} day(s) after claiming.</p>
                </div>
              </div>
              <div className="confirmation-buttons">
                <div className="confirm-purchase" onClick={this.initiateRedemption}>
                  CLAIM NOW
                </div>
                <div className="back-purchase" onClick={this.backToInitial}>
                  BACK
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    // Subscription gift confirmation
    const planId = giftCodeInfo.planId
    const currentPlanId = this.props.purchasedPlan.product_id
    const planTitle = this.planNames[planId]
    const currentPlanTitle = this.planNames[currentPlanId] || '';

    const action = this.checkIfUpgradeOrDowngrade(currentPlanTitle, planTitle)
    
    // Format dates if available
    let startDate = '';
    let endDate = '';
    if (giftCodeInfo.startDate) {
      startDate = new Date(giftCodeInfo.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }
    if (giftCodeInfo.endDate) {
      endDate = new Date(giftCodeInfo.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    return (
      <div className="claim-panel panel">
        <div className="title">Claim Gift</div>
        <div className="content">
          <div className="gift-message">
            Gift Details:
            <div className="gift-details">
              <h2>{planTitle}</h2>
              <div className="gift-description-text">
                {startDate && <p>Start Date: {startDate}</p>}
                {endDate && <p>End Date: {endDate}</p>}
                <p>Code: {this.state.giftcode}</p>
              </div>
            </div>
          </div>
          <div className="description-section">
            <div className="confirmation-message padding40">
              <h3 className="confirmation-title"> What you need to know:</h3>
              {action === 'upgrade' ?(
                <div className="explanation">
                  <p>Your subscription will be upgraded to{" "}
                    {planTitle.toUpperCase()}</p>
                </div>
              ) : null}
            </div>
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={this.initiateRedemption}>
                CONFIRM
              </div>
              <div className="back-purchase" onClick={this.backToInitial}>
                BACK
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderRentalSuccess() {
    const { giftCodeInfo, rentalResult } = this.state
    return (
      <div className="claim-panel panel">
        <div className="title">Gift Claimed!</div>
        <div className="content">
          <div className="gift-message">
            <div className="gift-details">
              <h2>{giftCodeInfo.videoTitle}</h2>
              <div className="gift-description-text">
                <p>Your movie rental has been activated!</p>
                <p>You can now watch this movie from your rentals.</p>
              </div>
            </div>
          </div>
          <div className="description-section">
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={() => this.props.history.push('/movie-night/my-rentals')}>
                GO TO MY RENTALS
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {loading, step} = this.state
    if (loading)
      return this.loading()

    switch (step) {
      case 'initial':
        return this.renderInitial()
      case 'confirmation':
        return this.renderConfirmation()
      case 'rental-success':
        return this.renderRentalSuccess()
      default:
        return this.renderInitial()
    }
  }
}
